import {SORT_FIELDS} from '../base.js'
import {NOT_AVAILABLE_FILTERS as sharedNotAvailableFilters} from '../common/searchSave.js'
import {
  AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID,
  CARS_WITHOUT_LICENSE_CATEGORY1_ID,
  CLASSIC_AND_COMPETITION_CATEGORY1_ID,
  FILTER_NAMES,
  SEGUNDA_MANO_CATEGORY1_ID,
  SORT_BY_INSTALMENT_PRICE,
  SORT_BY_KM,
  SORT_BY_PRICE,
  SORT_BY_RELEVANCE,
  SORT_BY_YEAR,
  VANS_AND_COMMERCIAL_CATEGORY1_ID
} from './ads.js'

export const FREQUENCY_NOTIFICATION_DAILY = 'DAILY'
export const FREQUENCY_NOTIFICATION_REALTIME = 'REAL_TIME'
export const frequencyNotificationData = {
  [FREQUENCY_NOTIFICATION_REALTIME]: {
    activeRealtimePush: true,
    activeRealtimeEmail: true
  },
  [FREQUENCY_NOTIFICATION_DAILY]: {
    activeRealtimePush: false,
    activeRealtimeEmail: false
  }
}

const SECOND_HAND_FILTERS_CONF = [
  FILTER_NAMES.MAKE,
  FILTER_NAMES.MODEL,
  FILTER_NAMES.VERSION,
  FILTER_NAMES.KMS,
  FILTER_NAMES.INSTALMENT,
  FILTER_NAMES.HAS_INSTALMENT,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.HAS_WARRANTY,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.ENVIRONMENTAL_LABEL,
  FILTER_NAMES.LITRES,
  FILTER_NAMES.PROVINCE,
  FILTER_NAMES.ONLY_PENINSULA,
  FILTER_NAMES.DRIVEN_WHEELS,
  FILTER_NAMES.BODY_TYPE,
  FILTER_NAMES.SELLER_TYPE,
  FILTER_NAMES.IS_CERTIFIED,
  FILTER_NAMES.SEARCH_TEXT,
  FILTER_NAMES.EQUIPMENTS,
  FILTER_NAMES.TRANSMISSION_TYPE,
  FILTER_NAMES.HP,
  FILTER_NAMES.DOOR,
  FILTER_NAMES.SEAT,
  FILTER_NAMES.LUGGAGE_CAPACITY,
  FILTER_NAMES.COLOR,
  FILTER_NAMES.HAS_PHOTO
]

const KM0_FILTERS_CONF = [
  FILTER_NAMES.SEARCH_TEXT,
  FILTER_NAMES.MAKE,
  FILTER_NAMES.MODEL,
  FILTER_NAMES.VERSION,
  FILTER_NAMES.INSTALMENT,
  FILTER_NAMES.HAS_INSTALMENT,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.HAS_STOCK,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.KMS,
  FILTER_NAMES.PROVINCE,
  FILTER_NAMES.ONLY_PENINSULA,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.ENVIRONMENTAL_LABEL,
  FILTER_NAMES.LITRES,
  FILTER_NAMES.LUGGAGE_CAPACITY,
  FILTER_NAMES.COLOR,
  FILTER_NAMES.DRIVEN_WHEELS,
  FILTER_NAMES.BODY_TYPE,
  FILTER_NAMES.DOOR,
  FILTER_NAMES.TRANSMISSION_TYPE,
  FILTER_NAMES.HP,
  FILTER_NAMES.SEAT,
  FILTER_NAMES.EQUIPMENTS,
  FILTER_NAMES.IS_CERTIFIED,
  FILTER_NAMES.OFFER_TYPE,
  FILTER_NAMES.HAS_PHOTO
]

const NEW_VEHICLE_FILTERS_CONF = [
  FILTER_NAMES.SEARCH_TEXT,
  FILTER_NAMES.MAKE,
  FILTER_NAMES.MODEL,
  FILTER_NAMES.VERSION,
  FILTER_NAMES.INSTALMENT,
  FILTER_NAMES.HAS_INSTALMENT,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.HAS_STOCK,
  FILTER_NAMES.PROVINCE,
  FILTER_NAMES.ONLY_PENINSULA,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.ENVIRONMENTAL_LABEL,
  FILTER_NAMES.LITRES,
  FILTER_NAMES.LUGGAGE_CAPACITY,
  FILTER_NAMES.COLOR,
  FILTER_NAMES.DRIVEN_WHEELS,
  FILTER_NAMES.BODY_TYPE,
  FILTER_NAMES.DOOR,
  FILTER_NAMES.TRANSMISSION_TYPE,
  FILTER_NAMES.HP,
  FILTER_NAMES.SEAT,
  FILTER_NAMES.EQUIPMENTS,
  FILTER_NAMES.IS_CERTIFIED,
  FILTER_NAMES.OFFER_TYPE,
  FILTER_NAMES.HAS_PHOTO
]

/**
 * @exports ALERTS_FILTERS_MAP
 */
export const ALERTS_FILTERS_MAP = {
  [SEGUNDA_MANO_CATEGORY1_ID]: [
    SECOND_HAND_FILTERS_CONF,
    NEW_VEHICLE_FILTERS_CONF,
    KM0_FILTERS_CONF,
    KM0_FILTERS_CONF,
    KM0_FILTERS_CONF,
    KM0_FILTERS_CONF
  ],
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: [
    [
      FILTER_NAMES.VERSION,
      FILTER_NAMES.INSTALMENT,
      FILTER_NAMES.HAS_INSTALMENT,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_WARRANTY,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.KMS,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.FUEL_TYPE,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.CATEGORY_2,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.VERSION,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_WARRANTY,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.CATEGORY_2,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.VERSION,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_WARRANTY,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: [
    [
      FILTER_NAMES.VERSION,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_WARRANTY,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.PROVINCE,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.CATEGORY_2,
      FILTER_NAMES.HAS_PHOTO
    ]
  ]
}

// Define only the paths that are different from the common ones
export const NOT_AVAILABLE_FILTERS = [...sharedNotAvailableFilters]

export const VANS_AND_COMMERCIAL_CATEGORY_API_LABEL = 'Industriales'

export const ALERT_NAME_PREFIX_I18N_OVERRIDES = {
  [VANS_AND_COMMERCIAL_CATEGORY_API_LABEL]: 'SEARCH_SAVE_VANS_AND_COMMERCIAL_CATEGORY'
}

/**
 * @exports ALERT_MATCHES_SORT
 */
export const ALERT_MATCHES_SORT = {
  ...SORT_BY_RELEVANCE,
  ...SORT_BY_PRICE,
  ...SORT_BY_INSTALMENT_PRICE,
  ...SORT_BY_KM,
  ...SORT_BY_YEAR
}

/**
 * @exports SORTABLE_ALERT_MATCH_FIELDS
 */
export const SORTABLE_ALERT_MATCH_FIELDS = {
  [SORT_FIELDS.PRICE]: match => match.ad?.price,
  [SORT_FIELDS.INSTALMENT]: match => match.ad?.financingInfo?.instalment,
  [SORT_FIELDS.YEAR]: match => match.ad?.year,
  [SORT_FIELDS.KM]: match => match.ad?.km
}
